import {NgModule} from '@angular/core';
import {FbUploadFileComponent} from './components/fb-upload-file/fb-upload-file.component';
import {DragDropFileUploadDirective} from './components/fb-upload-file/drag-drop.directive';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CameraDialogComponent } from './components/camera-dialog/camera-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import {  FormsModule } from '@angular/forms';


@NgModule({
  declarations: [FbUploadFileComponent, DragDropFileUploadDirective, CameraDialogComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatSelectModule, FormsModule],
  exports: [FbUploadFileComponent],
  providers: [],
})
export class FormbirdUploadModule {
}
